import { IbhFilterKeys } from '@hub/libs/constants';
import type { IbhFilterControl, IbhFilterValues } from '@hub/hooks/states/useIbhFilterValuesStore';
import { useTranslation } from 'next-i18next';
import { Checkbox } from '@hub/common/Checkbox/Checkbox';
import type { IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';

interface EnvironmentSectionProps {
  filterValues: IbhFilterValues;
  filterControl: IbhFilterControl;
  setFilterValue: (key: IbhFilterKeys, value: string | string[] | number | boolean | undefined | IbhDimensions) => void;
  isCollapsible?: boolean;
}

export const EnvironmentSection = ({
  setFilterValue,
  filterValues,
  filterControl,
  isCollapsible = false,
}: EnvironmentSectionProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  return (
    <>
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.DIRT_AND_DUST]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.DIRT_AND_DUST}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.DIRT_AND_DUST}`}
        value={
          !!filterControl[IbhFilterKeys.DIRT_AND_DUST] === true
            ? false
            : !!(filterValues[IbhFilterKeys.DIRT_AND_DUST] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.DIRT_AND_DUST, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.DIRT_AND_DUST`, { ns: 'bearing-hub/bearingHub' })}
      />
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.LOW_WATER_ABSORBTION]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.LOW_WATER_ABSORBTION}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.LOW_WATER_ABSORBTION}`}
        value={
          !!filterControl[IbhFilterKeys.LOW_WATER_ABSORBTION] === true
            ? false
            : !!(filterValues[IbhFilterKeys.LOW_WATER_ABSORBTION] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.LOW_WATER_ABSORBTION, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.LOW_WATER_ABSORBTION`, { ns: 'bearing-hub/bearingHub' })}
      />
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.CHEMICALS]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.CHEMICALS}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.CHEMICALS}`}
        value={
          !!filterControl[IbhFilterKeys.CHEMICALS] === true
            ? false
            : !!(filterValues[IbhFilterKeys.CHEMICALS] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.CHEMICALS, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.CHEMICALS`, { ns: 'bearing-hub/bearingHub' })}
      />
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.UNDERWATER_SPLASHWATER]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.UNDERWATER_SPLASHWATER}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.UNDERWATER_SPLASHWATER}`}
        value={
          !!filterControl[IbhFilterKeys.UNDERWATER_SPLASHWATER] === true
            ? false
            : !!(filterValues[IbhFilterKeys.UNDERWATER_SPLASHWATER] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.UNDERWATER_SPLASHWATER, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.UNDERWATER_SPLASHWATER`, { ns: 'bearing-hub/bearingHub' })}
      />
    </>
  );
};
